import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import colors from '../../../../../utils/colors';
import styles from './statsMobile.module.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { connect } from 'react-redux';
import StatsBox from '../StatsBox';
import { ReactComponent as MoneyIcon } from '../../../../../assets/images/money.svg';
import { ReactComponent as StorageIcon } from '../../../../../assets/images/storage.svg';

const mapStateToProps = (state) => {
    return {
        alignment: state.common.currency.alignment
    };
};

const StatsMobile = ({ currency, alignment, totalEarned, totalStreams, totalStorage }) => {
    const { t } = useTranslation();

    const formattedTotalEarned =
        alignment === 'left'
            ? `${currency.toUpperCase()} ${totalEarned}`
            : `${totalEarned} ${currency.toUpperCase()}`;

    return (
        <Box className={styles.stats}>
            <Slider
                dots={false}
                infinite
                speed={500}
                slidesToScroll={1}
                arroaws={false}
                swipe
                touchMove
                centerMode
                variableWidth
                adaptiveHeight>
                <div className={styles.statsBoxWrapper}>
                    <StatsBox
                        label={t('TotalEarned')}
                        Icon={MoneyIcon}
                        formattedValue={formattedTotalEarned}
                        color={colors.primary}
                    />
                </div>
                <div className={styles.statsBoxWrapper}>
                    <StatsBox
                        label={t('TotalStreams')}
                        Icon={PlayArrowIcon}
                        formattedValue={totalStreams}
                        color={colors.secondary}
                    />
                </div>
                <div className={styles.statsBoxWrapper}>
                    <StatsBox
                        label={t('TotalStorage')}
                        Icon={StorageIcon}
                        formattedValue={`${totalStorage}/100GB`}
                        color={colors.primary}
                    />
                </div>
            </Slider>
        </Box>
    );
};

export default connect(mapStateToProps, null)(StatsMobile);
